<template>
  <div id="app">
    <!-- 粒子特效容器，作为背景 -->
    <div id="particles-js"></div>

    <!-- 页面内容容器 -->
    <div class="page-content">
      <Header />
      <main class="main-container">
        <router-view/>
      </main>
      <Footer />
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';

export default {
  name: 'App',
  components: {
    Header,
    Footer,
  },
  mounted() {
    // DOM挂载后初始化particles.js
    // window.particlesJS是库挂载在window上的全局函数
    window.particlesJS('particles-js', {
      particles: {
        number: {
          value: 80, // 粒子数量
          density: {
            enable: true,
            value_area: 800 // 粒子分布区域
          }
        },
        color: {
          value: '#ffffff' // 粒子颜色
        },
        shape: {
          type: 'circle' // 粒子形状
        },
        opacity: {
          value: 0.5, // 粒子不透明度
          random: false
        },
        size: {
          value: 3, // 粒子大小
          random: true
        },
        line_linked: {
          enable: true,
          distance: 150, // 连接线距离
          color: '#ffffff', // 连接线颜色
          opacity: 0.4,
          width: 1
        },
        move: {
          enable: true,
          speed: 4, // 粒子移动速度
          direction: 'none',
          random: false,
          straight: false,
          out_mode: 'out',
          bounce: false
        }
      },
      interactivity: {
        detect_on: 'canvas',
        events: {
          onhover: {
            enable: true,
            mode: 'repulse' // 鼠标悬停效果
          },
          onclick: {
            enable: true,
            mode: 'push' // 鼠标点击效果
          },
          resize: true
        },
        modes: {
          repulse: {
            distance: 100,
            duration: 0.4
          },
          push: {
            particles_nb: 4
          }
        }
      },
      retina_detect: true
    });
  }
};
</script>

<style>
/* 全局样式 */
html, body {
  margin: 0;
  padding: 0;
  height: 100%;
  background-color: #0d2a4b; /* 添加一个深色底色，防止粒子特效加载前白屏 */
}

* {
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

/* 粒子效果容器样式 */
#particles-js {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 0; /* 置于最底层 */
}

/* #app 容器作为定位上下文 */
#app {
  position: relative;
  min-height: 100vh;
  width: 100%;
}

/* 页面内容容器，用于覆盖在粒子背景之上 */
.page-content {
  position: relative;
  z-index: 1; /* 确保内容在粒子层之上 */
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.main-container {
  flex: 1;
  /* 为主要内容区域设置一个半透明背景，使其与粒子背景融合得更好 */
  background-color: rgba(245, 247, 250, 0.9);
}

/* Element UI 分页组件样式覆盖 */
.el-pagination .btn-prev:hover,
.el-pagination .btn-next:hover,
.el-pagination .el-pager li:hover {
  border-color: #94a3b8 !important;
}

.el-pagination .btn-prev:active,
.el-pagination .btn-next:active,
.el-pagination .el-pager li:active {
  border-color: #94a3b8 !important;
}
</style>
